import { useState } from "react";
import { Menu, MenuItem, Stack, Typography, useTheme } from "@mui/material";

import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";
import { Iconify } from "../iconify";

interface SortOptions {
  label: string;
  value: string;
  onClick?: () => void;
}

interface SortDropdownProps {
  shortOptions: SortOptions[];
  value: string;
  containerStyle?: any;
  menuItemContainerStyle?: any;
  showShotsBy?: boolean;
  textColor?: string;
}

const DropDownMenu = ({
  shortOptions,
  value,
  containerStyle,
  menuItemContainerStyle,
  showShotsBy,
  textColor,
}: SortDropdownProps) => {
  const isMobile = useResponsive("down", "sm");
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = () => {
    handleClose();
  };

  return (
    <>
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"center"}
        onClick={handleClick}
        sx={{
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            textTransform: "none",
            borderColor: theme.palette.grey[300],
            borderRadius: 1,
            color: textColor ? textColor : theme.palette.primary.main,
            fontSize: isMobile ? "0.875rem" : "1rem",
            ...containerStyle,
          }}
        >
          {showShotsBy && Strings.productDetail.shortsBy} {value}
        </Typography>
        <Iconify
          icon={open ? "ri:arrow-up-s-line" : "ri:arrow-down-s-line"}
          color={textColor ? textColor : theme.palette.primary.main}
        />
      </Stack>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          marginTop: 2,
          "& .MuiPaper-root": {
            width: isMobile ? 200 : 225,
            maxWidth: isMobile ? "90%" : "auto",
            ...menuItemContainerStyle,
          },
        }}
      >
        {shortOptions?.map((shortOptions) => (
          <MenuItem
            key={shortOptions?.value}
            onClick={() => {
              shortOptions.onClick?.();
              handleSelect();
            }}
            selected={shortOptions?.value === value}
            sx={{
              borderRadius: 1,
            }}
          >
            <Typography
              sx={{
                color:
                  shortOptions?.value === value
                    ? theme.palette.primary.main
                    : "inherit",
                fontFamily: "Work Sans",
                fontSize: isMobile ? "0.9rem" : "1rem",
              }}
            >
              {shortOptions?.label}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export { DropDownMenu };
